import { render, staticRenderFns } from "./OrgSelector.vue?vue&type=template&id=0bbf291a&scoped=true&lang=pug"
import script from "./OrgSelector.vue?vue&type=script&lang=js"
export * from "./OrgSelector.vue?vue&type=script&lang=js"
import style0 from "./OrgSelector.vue?vue&type=style&index=0&id=0bbf291a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf291a",
  null
  
)

export default component.exports